/**
 * Inserts dictated text at the caret, adding spaces where needed (no space before punctuation).
 * Copy of the mermaidd util, so the apps don't import from each other.
 */
export const spliceDictatedText = (base: string, caret: number, spoken: string): string => {
  if (!spoken) return base;
  const before = base.slice(0, caret);
  const after = base.slice(caret);
  const needsLeadingSpace = before.length > 0 && /\S$/.test(before);
  const needsTrailingSpace = after.length > 0 && /^[^\s.,;:!?)\]}"']/.test(after);
  const insertion = `${needsLeadingSpace ? ' ' : ''}${spoken}${needsTrailingSpace ? ' ' : ''}`;
  return before + insertion + after;
};
